import axios from 'axios';
import {backendHost} from '../../config';

export const getPartnersById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/partners/${params.id}`);
};